"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.keys.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _layout = require("@citrus/layout");
var _inputSelect = require("@citrus/input-select");
var _button = require("@citrus/button");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilder2 = require("./PctyQuestionBuilder.Constants");
var _PctyQuestionBuilderEditConditional = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.Conditional.Question"));
var _PctyQuestionBuilderEditConditional2 = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.Conditional.Review"));
var _SectionTitle, _label, _SectionTitle2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var PctyQuestionBuilderEditConditional = function PctyQuestionBuilderEditConditional(_ref) {
  var bannerText = _ref.bannerText,
    conditionalExpression = _ref.conditionalExpression,
    onChangeConditionalExpression = _ref.onChangeConditionalExpression,
    questions = _ref.questions;
  var operators = [{
    value: _PctyQuestionBuilder2.CONDITIONAL_OPERATORS.EQUALS,
    label: 'equals'
  }, {
    value: _PctyQuestionBuilder2.CONDITIONAL_OPERATORS.NOT_EQUALS,
    label: 'not equals'
  }];
  var _useState = (0, _react.useState)(undefined),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedTriggerQuestion = _useState2[0],
    setSelectedTriggerQuestion = _useState2[1];
  var _useState3 = (0, _react.useState)(operators[0]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    selectedOperator = _useState4[0],
    setSelectedOperator = _useState4[1];
  var _useState5 = (0, _react.useState)(undefined),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    selectedTriggerResponse = _useState6[0],
    setSelectedTriggerResponse = _useState6[1];
  var _useState7 = (0, _react.useState)(conditionalExpression || ''),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    currentExpression = _useState8[0],
    setCurrentExpression = _useState8[1];
  var onTriggerQuestionChange = function onTriggerQuestionChange(value) {
    setSelectedTriggerQuestion(value);
    setSelectedTriggerResponse(undefined);
  };
  var onOperatorChange = function onOperatorChange(value) {
    setSelectedOperator(value);
  };
  var _onResponse = function onResponse(response) {
    setSelectedTriggerResponse(response);
  };
  var renderSelectedTriggerQuestion = function renderSelectedTriggerQuestion() {
    if (!questions || !selectedTriggerQuestion || !selectedTriggerQuestion.value) return null;

    // get the question by its id
    var selectedQuestion = questions.find(function (x) {
      return x.id === selectedTriggerQuestion.value;
    });
    if (!selectedQuestion) return null;
    return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEditConditional.default, {
      triggerQuestion: selectedQuestion,
      response: selectedTriggerResponse,
      onResponse: function onResponse(id, resp) {
        return _onResponse(resp);
      }
    });
  };
  var getValuesFromResponse = function getValuesFromResponse(triggerQuestion, response) {
    var formattedResponse = response;
    if (response && Array.isArray(response) && response[0]) {
      var tmpResponse = response.map(function (r) {
        return "".concat(r.optionId);
      });
      formattedResponse = triggerQuestion.typeId !== _questionBuilder.QUESTION_TYPE.checkbox ? tmpResponse[0] : (0, _toConsumableArray2.default)(tmpResponse);
    } else {
      formattedResponse = "".concat(formattedResponse);
    }

    // string it up!
    formattedResponse = JSON.stringify(formattedResponse);
    return formattedResponse;
  };
  var onClickAddClause = function onClickAddClause(conjuctionText) {
    var selectedQuestion = questions.find(function (x) {
      return x.id === selectedTriggerQuestion.value;
    });
    if (!selectedQuestion) return null;
    var clause = "{".concat(selectedTriggerQuestion.value, "} ").concat(selectedOperator.value, " ").concat(getValuesFromResponse(selectedQuestion, selectedTriggerResponse));
    var expression = clause;
    if ((0, _isNotNullOrEmpty.default)(currentExpression) && (0, _isNotNullOrEmpty.default)(conjuctionText)) {
      expression = currentExpression;
      // json.parse may fail depending on the expression!
      try {
        expression = JSON.parse(currentExpression); // re-parse so it doesn't keep tacking on quotes!
      } catch (_unused) {}
      expression = "".concat(expression, " ").concat(conjuctionText, " ").concat(clause);
    }
    setCurrentExpression(expression);
    onChangeConditionalExpression(expression);
    setSelectedTriggerQuestion(undefined);
    setSelectedOperator(operators[0]);
    setSelectedTriggerResponse(undefined);
  };
  var onClickClear = function onClickClear() {
    setCurrentExpression('');
    onChangeConditionalExpression('');
  };
  var triggerQuestionOptions = !questions ? [] : questions.map(function (item) {
    return {
      label: (0, _PctyQuestionBuilder.removeHtmlTags)((0, _PctyQuestionBuilder.decodeText)(item.question)),
      value: item.id
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "conditional-display-tab"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("p", null, bannerText))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, triggerQuestionOptions && triggerQuestionOptions.length > 0 && /*#__PURE__*/_react.default.createElement("div", null, _SectionTitle || (_SectionTitle = /*#__PURE__*/_react.default.createElement(_layout.SectionTitle, null, "Select Trigger Question")), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-9"
  }, /*#__PURE__*/_react.default.createElement(_inputSelect.SelectStatic, {
    automationId: "trigger-question-input",
    id: "trigger-question-input",
    key: "triggerQuestionInput",
    onChange: function onChange(value) {
      return onTriggerQuestionChange(value);
    },
    options: triggerQuestionOptions,
    value: selectedTriggerQuestion || undefined,
    className: "conditional-trigger-input",
    placeholder: 'Select Trigger Question...'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-3 pcty-padding-right"
  }, /*#__PURE__*/_react.default.createElement(_inputSelect.SelectStatic, {
    automationId: "operator-input",
    id: "operator-input",
    key: "operatorInput",
    onChange: function onChange(value) {
      return onOperatorChange(value);
    },
    options: operators,
    value: selectedOperator || '='
  }))), selectedTriggerQuestion && /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-top pcty-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginLeft: '15px'
    }
  }, _label || (_label = /*#__PURE__*/_react.default.createElement("label", {
    className: "pcty-input-label"
  }, "Choose the answer(s) below for the Question to appear")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '10px'
    }
  }, renderSelectedTriggerQuestion())))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-8"
  }, selectedTriggerQuestion && selectedTriggerResponse && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, currentExpression.length === 0 && /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
    id: 'trigger-add',
    onClick: function onClick() {
      return onClickAddClause();
    }
  }, "Add", ' '), currentExpression.length > 0 && /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
    id: 'trigger-add-with-and',
    onClick: function onClick() {
      return onClickAddClause(_PctyQuestionBuilder2.CONDITIONAL_CONJUNCTIONS.AND);
    }
  }, "Add with AND"), currentExpression.length > 0 && /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
    id: 'trigger-add-with-or',
    onClick: function onClick() {
      return onClickAddClause(_PctyQuestionBuilder2.CONDITIONAL_CONJUNCTIONS.OR);
    }
  }, "Add with OR")), currentExpression.length > 0 && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
    id: 'trigger-questions-clear',
    onClick: function onClick() {
      return onClickClear();
    }
  }, "Clear")))), currentExpression && currentExpression.length > 0 && /*#__PURE__*/_react.default.createElement("div", null, _SectionTitle2 || (_SectionTitle2 = /*#__PURE__*/_react.default.createElement(_layout.SectionTitle, null, "Review")), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row-float-fill pcty-flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-fluid pcty-padding-right review-details-container"
  }, /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEditConditional2.default, {
    currentExpression: currentExpression,
    questions: questions
  })))))));
};
PctyQuestionBuilderEditConditional.propTypes = {
  bannerText: _propTypes.default.string,
  conditionalExpression: _propTypes.default.string,
  onChangeConditionalExpression: _propTypes.default.func.isRequired,
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    typeId: _propTypes.default.number.isRequired,
    scenario: _propTypes.default.string,
    question: _propTypes.default.string.isRequired,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      value: _propTypes.default.string.isRequired
    })),
    answers: _propTypes.default.arrayOf(_propTypes.default.shape({
      optionId: _propTypes.default.string.isRequired
    })),
    knockout: _propTypes.default.bool,
    hint: _propTypes.default.string,
    correctFeedback: _propTypes.default.string,
    incorrectFeedback: _propTypes.default.string
  }))
};
PctyQuestionBuilderEditConditional.defaultProps = {
  bannerText: '',
  conditionalExpression: '',
  questions: []
};
var _default = exports.default = PctyQuestionBuilderEditConditional;